import { Nullable } from 'modules/types/common';
import { Visit, Disposition, EndReason } from './types';

export const declinedVisitDispositions = [Disposition.Declined];

export const hasDeclinedVisit = (visit: Nullable<Visit>) => {
  return declinedVisitDispositions.some(disposition => disposition === visit?.disposition);
};

export const canceledVisitDispositions = [Disposition.Bailed, Disposition.ConsumerCanceled];

export const hasCanceledVisit = (visit: Nullable<Visit>) => {
  return canceledVisitDispositions.some(disposition => disposition === visit?.disposition);
};

export const endedVisitDispositions = [Disposition.Completed, Disposition.ProviderWrapup];

export const hasEndedVisit = (visit: Nullable<Visit>) => {
  return endedVisitDispositions.some(disposition => disposition === visit?.disposition);
};

export const startedVisitDispositions = [Disposition.PreVisitScreening, Disposition.InProgress];

export const hasStartedVisit = (visit: Nullable<Visit>) => {
  return startedVisitDispositions.some(disposition => disposition === visit?.disposition);
};

export const transferVisitEndReasons = [
  EndReason.PROVIDER_DECLINE_AND_TRANSFER,
  EndReason.ASSISTANT_DECLINE_AND_TRANSFER,
  EndReason.CONSUMER_TRANSFER
];

export const isTransferringVisit = (visit: Nullable<Visit>) => {
  return transferVisitEndReasons.some(reason => reason === visit?.endReason);
};
